module.exports = __webpack_public_path__ + "static/media/vehicle-extra-finish.d8a1e4ef.svg";